import { Component, OnInit, Input, OnDestroy, ViewEncapsulation, Output, EventEmitter } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import 'rxjs/add/operator/takeUntil';
import { Subject } from 'rxjs';
import moment from 'moment';
moment.locale('de');
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-show-attached-reservations',
  templateUrl: './show-attached-reservations.component.html',
  styleUrls: ['./show-attached-reservations.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ShowAttachedReservations implements OnInit, OnDestroy {
  @Input() public selectedReservation: any;
  @Input() public mealOptions: any;
  @Output() passEntry: EventEmitter<any> = new EventEmitter();
  private ngUnsubscribe: Subject<any> = new Subject();
  constructor(public activeModal: NgbActiveModal, public translate: TranslateService) {
    this.translate.onLangChange.subscribe((event: any) => {});
  }

  ngOnInit() {
    const { attachedReservations, ...mainReservation } = this.selectedReservation;

    this.selectedReservation.attachedReservationsCustom = [
      mainReservation,
      ...this.selectedReservation.attachedReservations
    ];

    if (
      this.selectedReservation &&
      this.selectedReservation.attachedReservationsCustom &&
      this.selectedReservation.attachedReservationsCustom.length &&
      this.selectedReservation.attachedReservationsCustom.some((res: any) => res.parentId)
    ) {
      this.selectedReservation = this.transformHotelReservation(this.selectedReservation);
    } else {
      this.selectedReservation = this.transformPackageData(this.selectedReservation);
    }
  }

  transformPackageData(data: any) {
    const cateringPackage =
      data && data.reservationInfo.Packages && data.reservationInfo.Packages.includes('Package Code')
        ? data.reservationInfo.Packages.split('Package Code:')[0].trim()
        : '';
    if (cateringPackage) {
      data.cateringPackage = cateringPackage;
    }
    return {
      ...data,
      attachedReservationsCustom: (data.attachedReservationsCustom || []).map((item: any) => ({
        ...item,
        reservationInfo: {
          RatePlanCode:
            item && item.reservationInfo && item.reservationInfo.RatePlanCode ? item.reservationInfo.RatePlanCode : '',
          Packages:
            item &&
            item.reservationInfo &&
            item.reservationInfo.Packages &&
            item.reservationInfo.Packages.includes('Package Code')
              ? item.reservationInfo.Packages.split('Package Code:')[1].trim()
              : item.reservationInfo.Packages || ''
        }
      }))
    };
  }

  transformHotelReservation(data: any) {
    if (!(data.guestInfo && data.guestInfo.name)) {
      data.guestInfo = {
        name: data.guestData ? data.guestData.name : null,
        firstName: data.guestData ? data.guestData.firstName : null
      };
    }
    const cateringPackage =
      data && data.packages && data.packages.includes('Package Code')
        ? data.packages.split('Package Code:')[0].trim()
        : '';
    if (cateringPackage) {
      data.cateringPackage = cateringPackage;
    }

    return {
      ...data,
      attachedReservationsCustom: (data.attachedReservationsCustom || [])
        .sort((a: any, b: any) => {
          const roomA = a.roomNo;
          const roomB = b.roomNo;

          // both have roomNo → sort by roomNo
          if (roomA != null && roomB != null) {
            if (roomA !== roomB) {
              return roomA - roomB; // numeric
            }
            return a.id - b.id; // fallback
          }

          // only one has roomNo → prioritize it
          if (roomA != null) return -1;
          if (roomB != null) return 1;

          // neither has roomNo → sort by id
          return a.id - b.id;
        })
        .map((item: any) => ({
          reservationNo: item.bookingNumber,
          arrivalDate: item.arrivalDate ? item.arrivalDate.split(' ')[0] : null,
          departureDate: item.departureDate ? item.departureDate.split(' ')[0] : null,
          guestCount: item.guestCount,
          roomNo: item.roomNo,
          companyName: item.guestData && item.guestData.company ? item.guestData.company : null,
          attachedCode: item.attachedCode,
          childCount: item.childCount || 0,
          guestInfo: item.guestInfo
            ? item.guestInfo
            : {
                name: item.guestData ? item.guestData.name : null,
                firstName: item.guestData ? item.guestData.firstName : null,
                email: item.guestData ? item.guestData.email : null,
                phone: item.guestData ? item.guestData.phone : null,
                guestNotes: item.guestData && item.guestData.notes ? item.guestData.notes : ''
              },

          reservationInfo: {
            RatePlanCode: item.groupTags || '',
            Packages:
              item && item.packages && item.packages.includes('Package Code')
                ? item.packages.split('Package Code:')[1].trim()
                : item.packages || ''
          }
        }))
    };
  }

  fetchColor(board: string): string {
    const meal = this.mealOptions.find((option: any) => option.value === board);
    return meal ? meal.color : 'gray';
  }

  ngOnDestroy(): any {
    this.passEntry.emit();
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
